import clsx from 'clsx';

import {useAppForm} from '@/providers/components/formProvider';

type FormStepsButtonsPropsT = {
  formId: string;
  className?: string;
};

function FormStepsButtons({formId, className}: FormStepsButtonsPropsT) {
  const {
    state: {steps, step, loading},
    goToStep,
  } = useAppForm({formId});

  if (!steps?.length || loading) return null;

  return (
    <div className={clsx('steps flex w-full flex-col gap-2 md:flex-row', className)}>
      {steps.map(({step: stepIndex, label}, index) => (
        <button
          type="button"
          key={index}
          onClick={() => goToStep(stepIndex)}
          className={clsx('ti-btn w-full', stepIndex === step ? 'ti-btn-primary-full' : 'ti-btn-outline-secondary')}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default FormStepsButtons;
